export type ToolId = string;

// tslint:disable-next-line:interface-over-type-literal
export type Tool = {
    id: ToolId;                     /* the unique ID of the tool that does not change with database update */
    
    /* For ToolCard--default */
    name: string;                   /* the name (presumably unique) */
    timeRange: string;              /* the range in the form xx-xx (minutes) */
    participantsRange: string;      /* just figure this one out */

    /* For ToolCard--expanded */
    shortDescription: string;       /* the short description to display in the expanded ToolCard */
    
    /* For ToolCard modal */
    sources: string[];              /* an array of links, ordered by importance */
    tags: string[];

    /* For TimelineCard */
    timeDefault: number;            /* the lower bound of the time range */
    participantsDefault: number;    /* unused for now */
}

export interface IToolsNextResponse {
    requestTime: number,
    
    totalCount: number,
    data: Tool[]
}

export interface IToolsBatchResponse {
    data: Tool[]
}

export class Tools {
    public static loadSequential(requestTime: number, start: number, count: number, search: string, done?: (response: IToolsNextResponse) => void, failed?: () => void) : void {
        
        window.fetch((window as any).API_LOCATION+"/tools/next", {
            body: JSON.stringify({
                "requestTime": requestTime,
                "start": start,
                "count": count,
                "order": "ascending",
                "search" : search
            }),
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            method: "POST",
            mode: "cors",
            redirect: "error",
            referrer: "no-referrer"
        })
        .then((rawResponse: any) => { 
            return rawResponse.json();
        })
        .then((decodedResponse: any) => {
            if(done) {
                done(decodedResponse as IToolsNextResponse);
            }
        })
        .catch(failed);
    }

    public static loadBatch(toolIds: ToolId[], done?: (response: IToolsBatchResponse) => void, failed?: () => void) : void {
        
        window.fetch((window as any).API_LOCATION+"/tools/batch", {
            body: JSON.stringify({
                "toolIds": toolIds
            }),
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            method: "POST",
            mode: "cors",
            redirect: "error",
            referrer: "no-referrer"
        })
        .then((rawResponse: any) => { 
            return rawResponse.json();
        })
        .then((decodedResponse: any) => {
            if(done) {
                done(decodedResponse as IToolsBatchResponse);
            }
        })
        .catch(failed);
    }
}


// WEBPACK FOOTER //
// ./src/Api/Tools.ts